import React from 'react';
import { Disclosure, Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import FontDesign from './fontDesign';
import ButtonDesign from './buttonDesign';
import HeaderDesign from './headerDesign';
import ContentAreaDesign from './contentAreaDesign';
import FooterDesign from './footerDesign';
import PaddleDesign from './paddleDesign';
import DesignSelector from './designSelector';
import LeaderboardDesign from './leaderboardDesign';
import LogoDesign from './logoDesign';

export default function DesignSection({
    auctionData,
    setAuctionData,
    setEditedAuctionData,
    handleLogoChange,
    handleLogoDelete,
    eventDisplayImageLoader,
    eventRightLogoLoader,
    eventLeftLogoLoader,
    onSetupSectionChange,
}) {
    const handleTabClick = (tab) => {
        if (tab === 'Auction') {
            onSetupSectionChange(false);
        } else if (tab === 'Event displays') {
            onSetupSectionChange(true);
        }
    }
    return (
        <div className="flex w-full justify-center px-4 pt-2">
            <div className="w-full max-w-md">
                <TabGroup>
                    <TabList className="flex gap-2 bg-white rounded-full p-2 border border-gray-700 h-12 w-fit mx-auto">
                        {['Auction', 'Event displays'].map((name, idx) => (
                            <Tab
                                onClick={() => handleTabClick(name)}
                                key={name}
                                className={({ selected }) =>
                                    `px-4 py-1 rounded-full text-sm font-semibold transition-colors duration-150
                                    focus:outline-none
                                    ${selected
                                ? 'bg-gray-200 text-black-200 shadow-sm'
                                : 'bg-white text-gray-600'}
                                    ${idx === 0 ? 'ml-1' : 'ml-0'} ${idx === 1 ? 'mr-1' : 'mr-0'}`
                                }
                            >
                                {name}
                            </Tab>
                        ))}
                    </TabList>
                    <TabPanels className="mt-3">
                        <TabPanel key={'Auction'} className="rounded-xl bg-white/5 p-3">
                            {/* <!-- font contents --> */}
                            <Disclosure as="div" defaultOpen={true} className="px-9 pt-4 border-b pb-[24px]">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex justify-between w-full items-center">
                                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Font</p>
                                            <img 
                                                src={open?"/images/auction-hide-dropdown.svg":
                                                    "/images/auction-show-dropdown.svg"} 
                                                className="cursor-pointer header-dropdown" 
                                                alt="dropdown-icon" loading="lazy" />
                                        </Disclosure.Button>
                                        <Disclosure.Panel className="auction-rule-content list-none">
                                            <FontDesign auctionData={auctionData}
                                                setAuctionData={setAuctionData} setEditedAuctionData={setEditedAuctionData} />
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                            {/* <!-- buttons --> */}
                            <Disclosure as="div" defaultOpen={true} className="px-9 pt-4 border-b pb-[24px]">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex justify-between w-full items-center">
                                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Buttons</p>
                                            <img 
                                                src={open?"/images/auction-hide-dropdown.svg":"/images/auction-show-dropdown.svg"}
                                                className="cursor-pointer header-dropdown" 
                                                alt="dropdown-icon" loading="lazy" />
                                        </Disclosure.Button>
                                        {/* <!-- color content --> */}
                                        <Disclosure.Panel className="button-content">
                                            <ButtonDesign auctionData={auctionData} 
                                                setAuctionData={setAuctionData} setEditedAuctionData={setEditedAuctionData} />
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                            {/* <!-- header --> */}
                            <Disclosure as="div" defaultOpen={true} className="px-9 pt-4 border-b pb-[24px]">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex justify-between w-full items-center">
                                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Header</p>
                                            <img
                                                src={open?"/images/auction-hide-dropdown.svg":"/images/auction-show-dropdown.svg"}
                                                className="cursor-pointer header-dropdown" 
                                                alt="dropdown-icon" loading="lazy" />
                                        </Disclosure.Button>
                                        {/* <!-- color content --> */}
                                        <Disclosure.Panel className="header-content">
                                            <HeaderDesign auctionData={auctionData} 
                                                setAuctionData={setAuctionData} setEditedAuctionData={setEditedAuctionData} />
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                            {/* <!-- content area --> */}
                            <Disclosure as="div" defaultOpen={true} className="px-9 pt-4 border-b pb-[24px]">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex justify-between w-full items-center">
                                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Content area</p>
                                            <img
                                                src={open?"/images/auction-hide-dropdown.svg":"/images/auction-show-dropdown.svg"}
                                                className="cursor-pointer header-dropdown" 
                                                alt="dropdown-icon" loading="lazy" />
                                        </Disclosure.Button>
                                        {/* <!-- color content --> */}
                                        <Disclosure.Panel className="contents">
                                            <ContentAreaDesign auctionData={auctionData} 
                                                setAuctionData={setAuctionData} setEditedAuctionData={setEditedAuctionData} />
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                            {/* <!-- footer area --> */}
                            <Disclosure as="div" defaultOpen={true} className="px-9 pt-4 border-b pb-[24px]">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex justify-between w-full items-center">
                                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Footer</p>
                                            <img
                                                src={open?"/images/auction-hide-dropdown.svg":"/images/auction-show-dropdown.svg"}
                                                className="cursor-pointer header-dropdown" 
                                                alt="dropdown-icon" loading="lazy" />
                                        </Disclosure.Button>
                                        {/* <!-- color content --> */}
                                        <Disclosure.Panel className="footer-content">
                                            <FooterDesign auctionData={auctionData} 
                                                setAuctionData={setAuctionData} setEditedAuctionData={setEditedAuctionData} />
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                            {/* <!-- paddle area --> */}
                            <Disclosure as="div" defaultOpen={true} className="px-9 pt-4 ">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="flex justify-between w-full items-center">
                                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Paddle</p>
                                            <img
                                                src={open?"/images/auction-hide-dropdown.svg":"/images/auction-show-dropdown.svg"}
                                                className="cursor-pointer header-dropdown"
                                                alt="dropdown-icon" loading="lazy" />
                                        </Disclosure.Button>
                                        <Disclosure.Panel className="paddle-content">
                                            <PaddleDesign auctionData={auctionData} 
                                                setAuctionData={setAuctionData} setEditedAuctionData={setEditedAuctionData} />
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                        </TabPanel>
                        <TabPanel key={'Event displays'} className="rounded-xl bg-white/5 p-3">
                            <DesignSelector
                                auctionData={auctionData} 
                                setAuctionData={setAuctionData}
                                setEditedAuctionData={setEditedAuctionData}
                            />
                            <LeaderboardDesign
                                auctionData={auctionData} 
                                setAuctionData={setAuctionData}
                                setEditedAuctionData={setEditedAuctionData}
                                handleLogoChange={handleLogoChange}
                                handleLogoDelete={handleLogoDelete}
                                eventDisplayImageLoader={eventDisplayImageLoader}
                            />
                            <LogoDesign
                                auctionData={auctionData}
                                setAuctionData={setAuctionData}
                                setEditedAuctionData={setEditedAuctionData}
                                handleLogoChange={handleLogoChange}
                                handleLogoDelete={handleLogoDelete}
                                eventRightLogoLoader={eventRightLogoLoader}
                                eventLeftLogoLoader={eventLeftLogoLoader}
                            />
                        </TabPanel>
                    </TabPanels>
                </TabGroup>
            </div>
        </div>
    )
}
